import { useContext, useMemo } from "react";

import { useTaskInlineActions } from "components/Actions/InlineActions/hooks";
import Table from "components/Table";
import TableContext from "context/table/tableContext";
import {
    DEVICE_GROUP_DETAILS_TASK_COLUMNS,
    FILTER_NAMES,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    usePermissions
} from "shared";

const DeviceGroupTasks = () => {
    const { detailsData } = useContext(TableContext);

    const { deviceGroupActions } = useTaskInlineActions();
    const { isReadTaskNotAllowed } = usePermissions();

    const { id } = detailsData;

    const innerTableQueryParams = useMemo(
        () => ({
            [FILTER_NAMES.GroupId]: id
        }),
        [id]
    );

    return (
        <Table
            name={TABLE_NAMES.Tasks}
            nameForFilters={TABLE_NAMES_WITH_FILTERS.DeviceGroupDetailTasks}
            hasNoPermissionToRead={isReadTaskNotAllowed}
            isInnerTable
            initialColumns={DEVICE_GROUP_DETAILS_TASK_COLUMNS}
            inlineActions={deviceGroupActions}
            idType={ID_TYPE.Id}
            sortFromNewest
            outerDetailsData={{
                mainTableName: TABLE_NAMES.DeviceGroups
            }}
            innerTableQueryParams={innerTableQueryParams}
        />
    );
};

export default DeviceGroupTasks;
